const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-script'

let recaptchaPromise = null

export const loadRecaptchaScript = siteKey => {
  if (typeof window === 'undefined') return Promise.resolve()

  if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
    return Promise.resolve(window.grecaptcha)
  }

  if (recaptchaPromise) {
    return recaptchaPromise
  }

  const key = siteKey || process.env.VUE_APP_RECAPTCHA_SITE_KEY
  if (!key) {
    return Promise.reject(new Error('reCAPTCHA site key is missing. Pastikan SITE_KEY disetel di environment.'))
  }

  recaptchaPromise = new Promise((resolve, reject) => {
    let script = document.getElementById(RECAPTCHA_SCRIPT_ID)

    if (!script) {
      script = document.createElement('script')
      script.id = RECAPTCHA_SCRIPT_ID
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(key)}`
      script.async = true
      script.defer = true

      script.onload = () => {
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            resolve(window.grecaptcha)
          })
        } else {
          resolve()
        }
      }

      script.onerror = error => {
        recaptchaPromise = null
        if (script.parentNode) {
          script.parentNode.removeChild(script)
        }
        reject(error)
      }

      document.head.appendChild(script)
    } else if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(() => {
        resolve(window.grecaptcha)
      })
    } else {
      script.addEventListener('load', () => {
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            resolve(window.grecaptcha)
          })
        } else {
          resolve()
        }
      })
      script.addEventListener('error', error => {
        recaptchaPromise = null
        reject(error)
      })
    }
  })

  return recaptchaPromise
}

export default loadRecaptchaScript
